import { useQuery } from "react-query";
import axios from "axios";

export const USE_QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  keepPreviousData: true,
  staleTime: 5 * 60 * 1000, // treat as fresh for 5 min
  cacheTime: 30 * 60 * 1000, // keep in memory for 30 min
};

export default function useFetchGraphData(params, endpoint) {
  return useQuery(
    [endpoint, params],
    async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/${endpoint}`,
        { params }
      );
      return data;
    },
    {
      ...USE_QUERY_OPTIONS,
      enabled: !!params,
    }
  );
}
